export default "__VITE_ASSET__DVUrdx1g__"